import { Component, OnInit } from '@angular/core';
import { Inspection } from '../../shared/models/index';
import { InspectionService, InspectionModelService } from '../../shared/services/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './new.component.html',
    standalone: false
})
export class InspectionNewPageComponent extends BaseModalPageComponent implements OnInit {
  inspection: Inspection;
  errorMessage: string;
  isModel = false;
  public processing = false;

  constructor(
    private inspectionService: InspectionService,
    private inspectionModelService: InspectionModelService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const isModel = params['isModel'];
      this.isModel = isModel === 'true';
    });
  }

  saveInspection(inspection: Inspection): void {
    this.processing = true;
    if (this.isModel === true) {
      this.inspectionModelService.newModel(inspection).subscribe((el) => {
        this.processing = false;
        this.inspection = el;
        this.goToBack();
      });
    } else {
      this.inspectionService.newInspection(inspection).subscribe((el) => {
        this.processing = false;
        this.inspection = el;
        this.goToBack();
      });
    }
  }

  cancel(): void {
    this.goToBack();
  }
}
